import React from 'react'
import styles from './TagPill.module.css'
import classNames from 'classnames'
import { getIcon } from '../icons/utils'

type TagPillProps = {
  size: 'small' | 'medium' | 'large'
  label: string
  color?: string
  textColor?: string
  variant?: 'primary' | 'secondary'
  onDelete?: () => void
  onClick?: () => void
}

export const TagPill: React.FC<TagPillProps> = ({
  size = 'small',
  label,
  color = 'var(--primary-light)',
  textColor = 'black',
  variant = 'primary',
  onDelete,
  onClick,
}) => {
  return (
    <>
      {!onClick && (
        <div
          className={classNames(styles.tagPill, styles[`tagPill_${variant}`], styles[`tagPill_${size}`])}
          style={{ background: color }}
        >
          <label className={styles.text} style={{ color: textColor }}>
            {label}
          </label>
          {onDelete && (
            <button className={styles.deleteButton} onClick={onDelete}>
              <span>{getIcon('close')}</span>
            </button>
          )}
        </div>
      )}
      {onClick && (
        <button
          onClick={onClick}
          className={classNames(styles.tagPill, styles[`tagPill_${variant}`], styles[`tagPill_${size}`])}
          style={{ background: color }}
        >
          <label className={styles.text} style={{ color: textColor }}>
            {label}
          </label>
        </button>
      )}
    </>
  )
}
